import { constants, typographyStyles } from "@newsela/angelou";
const { colors } = constants;
const { textLObj } = typographyStyles;

export const wrapperCss = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  margin: "24px 0",
};

export const messageCss = {
  marginTop: "48px",
  marginBottom: "24px",
  color: colors.ui.neutral[500],
  textAlign: "center",
  maxWidth: "600px",
  ...textLObj,
};

export const createdByYouMessageWrapperCss = {
  display: "block",
  div: {
    display: "inline",
  },
};

export const buttonRootCss = {
  marginTop: "24px",
};

export const createTextSetButtonCss = {
  justifyContent: "center",
};
